"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgIconHandPointer = function SvgIconHandPointer(props) {
  return /*#__PURE__*/_react.default.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    "aria-label": "hand pointer icon",
    fill: "currentColor",
    fillRule: "evenodd"
  }, props), /*#__PURE__*/_react.default.createElement("title", null, 'Hand Pointer Icon'), /*#__PURE__*/_react.default.createElement("path", {
    clipRule: "evenodd",
    d: "M39 22.679v7.071c0 .227-.026.454-.078.675l-2.357 10.018a2.947 2.947 0 01-2.869 2.271H18.375a2.947 2.947 0 01-2.383-1.213L6.564 28.537a2.947 2.947 0 014.765-3.466l2.332 3.205V7.946a2.946 2.946 0 115.893 0V22.68h.589v-2.947a2.946 2.946 0 015.893 0v2.947h.589v-1.77a2.946 2.946 0 015.893 0v1.768h.59a2.947 2.947 0 015.892 0zM21 28h-2v7h2v-7zm6.482 0h-2v7h2v-7zm6.482 0h-2v7h2v-7z"
  }));
};

var _default = SvgIconHandPointer;
exports.default = _default;